import React, { forwardRef } from "react";
import TextField from "@material-ui/core/TextField";
import PhoneInput from "react-phone-number-input/input";
import "react-phone-number-input/style.css";

const phoneInput = (props, ref) => {
  return <TextField {...props} inputRef={ref} fullWidth margin="dense" />;
};
export default forwardRef(phoneInput);
